import { FC } from 'react';

import { useParams, useNavigate } from 'react-router-dom';

import { usePageTitle } from 'hooks/usePageTitle';

import { Button } from 'components/parts/Button';
import Success from 'images/icon/success.svg';

import styles from './RewardSuccess.module.scss';
export const RewardSuccess: FC = () => {
  const navigate = useNavigate();
  const { id: idParam } = useParams<{ id?: string }>();
  const id =
    idParam === 'halfway' || idParam === 'almost' || idParam === 'perfect' ? idParam : 'halfway';

  usePageTitle(
    id === 'halfway'
      ? '5エリアクリア'
      : id === 'almost'
      ? '10エリアクリア'
      : id === 'perfect'
      ? 'パーフェクト賞'
      : '賞品受け取り'
  );

  return (
    <div className={styles.wrapper}>
      <div className={styles.inner}>
        <div className={styles.body}>
          <img src={Success} alt="" className={styles.Icon} />
          <p className={styles.message}>二次元コード読み取り成功！</p>
        </div>
        <div className={styles.foot}>
          <Button text="ホームに戻る" styleType="secondary" handleClick={() => navigate('/home')} />
        </div>
      </div>
    </div>
  );
};
